<mat-form-field class="input-search">
  <input
    data-type="input-rule-search"
    type="search"
    autocomplete="off"
    matInput
    [placeholder]="placeholder">
  <mat-icon matSuffix>search</mat-icon>
</mat-form-field>
